import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Quote } from "lucide-react";

interface TestimonialCardProps {
  name: string;
  text: string;
  delay?: number;
}

export function TestimonialCard({ name, text, delay = 0 }: TestimonialCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
      transition={{ duration: 0.5, delay }}
      className="card-premium relative"
    >
      <Quote className="w-10 h-10 text-primary/20 absolute top-6 right-6 z-0" />
      <p className="text-foreground leading-relaxed mb-6 text-center relative z-10 pr-12">
        "{text}"
      </p>
      <div className="flex items-center justify-center md:justify-start gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold">
          {name.charAt(0)}
        </div>
        <p className="font-medium text-primary">{name}</p>
      </div>
    </motion.div>
  );
}
